// extracted by mini-css-extract-plugin
module.exports = {"flipFlop":"flipflop_flipFlop__HzDKx","body":"flipflop_body__HypIN","image":"flipflop_image__kDufX","caption":"flipflop_caption__gEIku","flipped":"flipflop_flipped__777Ao"};